import { render } from "./OffcanvasRefund.vue?vue&type=template&id=6d8e3034&scoped=true"
import script from "./OffcanvasRefund.vue?vue&type=script&lang=js"
export * from "./OffcanvasRefund.vue?vue&type=script&lang=js"

import "./OffcanvasRefund.vue?vue&type=style&index=0&id=6d8e3034&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8e3034"]])

export default __exports__